import { render, staticRenderFns } from "./myEmailPage.vue?vue&type=template&id=c181601a&scoped=true&"
import script from "./myEmailPage.vue?vue&type=script&lang=ts&"
export * from "./myEmailPage.vue?vue&type=script&lang=ts&"
import style0 from "./myEmailPage.vue?vue&type=style&index=0&id=c181601a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c181601a",
  null
  
)

export default component.exports